import { IAppState } from '../../types/store/reducer';
import { AppActions } from '../../types/store/action';
import {
  SET_WINDOW_VARIABLES,
  SET_WINDOW_VARIABLE_FETCHING_ERROR
} from '../actions/actionTypes';

const initialState: IAppState = {
  currency: '',
  localeId: '',
  countryCode: '',
  lunaAvailable: undefined,
  stadiaAvailable: undefined,
  windowVariablesInitialised: false,
  windowVariablesFetchingError: false
};

export default function app(
  state = initialState,
  action: AppActions
): IAppState {
  switch (action.type) {
    case SET_WINDOW_VARIABLES:
      return {
        ...state,
        currency: action.currency,
        localeId: action.localeId,
        countryCode: action.countryCode,
        lunaAvailable: action.luna_available,
        stadiaAvailable: action.stadia_available,
        windowVariablesInitialised: true
      };
    case SET_WINDOW_VARIABLE_FETCHING_ERROR:
      return {
        ...state,
        windowVariablesInitialised: true,
        windowVariablesFetchingError: true
      };
    default:
      return state;
  }
}
